import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KvkkService } from 'app/services/yoklama/kvkk.service';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-kvkk-dialog',
  templateUrl: './kvkk-dialog.component.html',
  styleUrls: ['./kvkk-dialog.component.css'],
})
export class KvkkDialogComponent  implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;

  constructor(
    private fb: FormBuilder,
    private kvkkService: KvkkService,
    private auth: UnifiedAuthService,
    public alertService: CustomToastrService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<KvkkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

pdfUrl: SafeResourceUrl | null = null;
  ngOnInit(): void {
  this.getKvkkPdf().subscribe(blob => {
  const url = URL.createObjectURL(blob);
  this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
});
  }

  // ======================
  // FORMS
  // ======================
  kvkkForm = this.fb.group({
    read: [false, Validators.requiredTrue],
  });
  agreementForm = this.fb.group({
    accepted: [false, Validators.requiredTrue],
  });
  consentForm = this.fb.group({
    consent: [false, Validators.requiredTrue], // 🔥 kritik
  });
  // ======================
  // DEVICE INFO
  // ======================
  getIp(): Promise<string> {
    return fetch('https://checkip.amazonaws.com')
      .then((r) => r.text())
      .then((ip) => ip.trim());
  }
  getUserAgent(): string {
    return navigator.userAgent;
  }

  getKvkkPdf() {
  return this.http.get(
    'https://ubys.ankara.edu.tr/Resources/kvkk.pdf',
    {
      responseType: 'blob',
      headers: {
        'com.ankarauni.au_mobile_v2': 'com.ankarauni.au_mobile_v2'
      }
    }
  );
}
  // ======================
  // FINAL ONLY SUBMIT
  // ======================
  async completeFlow() {
    if (!this.consentForm.valid) {
      this.alertService.message('Açık rıza verilmedi.', 'Bilgi', {
        messageType: ToastrMessageType.Info,
        position: ToastrPosition.TopFullWidth,
      });

      return;
    }
    try {
      const user = this.data.user;
      const lastApproval = this.data.lastApproval;
      const hasAnyRecord = this.data.hasAnyRecord;

      const ip = await this.getIp();

      let body: any;

      if (!hasAnyRecord) {
        body = {
          item: {
            studentId: user.userNo,
            consentType: 'CONSENT_COMPLETED', // sadece type farkı
            isAccepted: true,
            policyVersion: 'v1',
            source: 'web',
            ipAddress: ip,
            userAgent: this.getUserAgent(),
          },
        };
      } else if (lastApproval && !lastApproval.isAccepted) {
        body = {
          item: {
            id: lastApproval.id,
            studentId: user.userNo,
            consentType: 'CONSENT_COMPLETED',
            isAccepted: true,
            policyVersion: lastApproval.policyVersion,
            source: 'web',
            ipAddress: ip,
            userAgent: this.getUserAgent(),
          },
        };
      }

      await this.kvkkService.saveKvkk(body).toPromise();

      // local update
      user.kvkkApprovals.push({
        id: lastApproval?.id ?? 0,
        studentId: user.userNo,
        consentType: 'CONSENT_COMPLETED', // burada KVKK kalabilir (frontend mapping)
        isAccepted: true,
        policyVersion: lastApproval?.policyVersion ?? 'v1',
        source: 'web',
        ipAddress: ip.trim(),
      });

      this.auth.updateKvkkApprovals({
        Id: lastApproval?.Id ?? 0,
        StudentId: user.userNo,
        ConsentType: 'CONSENT_COMPLETED',
        IsAccepted: true,
        PolicyVersion: lastApproval?.policyVersion ?? 'v1',
        Source: 'web',
        IpAddress: ip.trim(),
      });

      this.dialogRef.close(true);
    } catch (err) {
      console.error('KVKK error', err);
    }
  }
}
